<div class="common-padding pn-page">
  <div class="heading p-0 mt-3 mb-4">
    <div class="d-flex align-items-center flex-wrap pn-heading-copy">
      <span class="span-create-edit-hoshin color">PUSH NOTIFICATION</span>
      <a href="assets/userguides/ERG_UG_PushNotification.pdf" download class="download-link">User Guide</a>
      <a routerLink="/push-notification-logs" class="download-link">Sent Notifications</a>
    </div>
  </div>

  <div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="notificationSuccess">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">Notification request completed. You can view it in Sent Notifications.</span>
  </div>
  <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="notificationFailure">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">{{errorMsg}} Check Sent Notifications before trying again; the request may have been accepted.</span>
  </div>
  <div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="copySuccess">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">Emails copied to clipboard!</span>
  </div>
  <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="copyFailure">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">Unable to copy emails. Check browser permissions and try again.</span>
  </div>
  <div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="usersAdded">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">People added successfully!</span>
  </div>
  <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="noMemberFound">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span class="pn-alert-text">{{noRecipientFoundMessage}}</span>
  </div>

  <form class="pn-notification-form" (ngSubmit)="sendNotification()" action="" name="notificationForm" #notificationForm="ngForm"
    enctype="multipart/form-data">

    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <span class="pn-section-number">01</span>
        <i class="fa fa-users pn-icon-spacing" aria-hidden="true"></i> Audience
      </div>
      <div class="card-body">
        <div class="pn-field-grid">
          <div class="pn-form-field">
            <label for="selectBpg" class="col-form-label">Select ERG<span class="star"> *</span></label>
            <ng-select id="selectBpg" placeholder="--Select ERG--" class="custom" [items]="bpgList" name="bpgName"
              bindLabel="bpgName" bindValue="bpgId" [(ngModel)]="bpgId" (change)="bpgChange($event)" required>
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.bpgName}}">{{item.bpgName}}</div>
              </ng-template>
            </ng-select>
          </div>

          <div class="pn-form-field">
            <label for="selecSite" class="col-form-label">Select Site<span class="star"> *</span></label>
            <ng-select id="selecSite" placeholder="--Select Site--" class="custom" [items]="siteList" name="siteName"
              bindLabel="siteName" [multiple]="true" (change)="siteChange($event)" [(ngModel)]="siteId"
              required></ng-select>
            <div class="pn-hint-text">
              <i class="fa fa-info-circle pn-hint-icon" aria-hidden="true"></i> Choosing All Sites switches Members to ERG Admins. All Sites supports ERG Admins or Lead Admins only.
            </div>
          </div>
        </div>

        <div class="pn-form-row-split" *ngIf="bpgId !== null && bpgId !== undefined && siteId && siteId.length > 0">
          <div class="pn-form-field pn-recipient-type">
            <span class="col-form-label">Send To<span class="star"> *</span></span>
            <div class="pn-radio-row" role="radiogroup" aria-label="Recipient type">
              <ng-container *ngIf="!allSitesSelected">
                <label class="pn-radio-option" [class.active]="recipientType === 'MEMBERS'">
                  <input type="radio" name="recipientType" value="MEMBERS" [(ngModel)]="recipientType"
                    (change)="onRecipientTypeChange()"> Members
                </label>
              </ng-container>
              <label class="pn-radio-option" [class.active]="recipientType === 'ERG_ADMIN'">
                <input type="radio" name="recipientType" value="ERG_ADMIN" [(ngModel)]="recipientType"
                  (change)="onRecipientTypeChange()"> ERG Admins
              </label>
              <label class="pn-radio-option" [class.active]="recipientType === 'ERG_LEAD_ADMIN'">
                <input type="radio" name="recipientType" value="ERG_LEAD_ADMIN" [(ngModel)]="recipientType"
                  (change)="onRecipientTypeChange()"> ERG Lead Admins
              </label>
            </div>
            <p class="pn-hint-text mb-0">
              <i class="fa fa-info-circle pn-hint-icon" aria-hidden="true"></i> Changing the audience reloads recipients and clears manual additions.
            </p>
          </div>

          <div class="pn-form-field pn-filter-toggle-field" *ngIf="recipientType === 'MEMBERS'">
            <button type="button" class="btn pn-filter-toggle" [class.active]="showJoinedDateField"
              [attr.aria-pressed]="showJoinedDateField" (click)="showJoinedDateFilter()">
              <i class="fa mr-1" [class.fa-check]="showJoinedDateField" [class.fa-filter]="!showJoinedDateField"
                aria-hidden="true"></i>
              Filter by joined date
            </button>
          </div>
        </div>

        <div class="pn-form-field" *ngIf="showJoinedDateField && recipientType === 'MEMBERS'">
          <label for="filterByDate" class="col-form-label">Filter By Joined Date<span class="star"> *</span></label>
            <ng-select id="filterByDate" placeholder="--Select By--" class="custom" [items]="filterList"
              name="filterName" bindLabel="filterName" bindValue="filterId" [(ngModel)]="selectedFilter"
              (change)="getChapterMembersEmails()" required></ng-select>
        </div>

        <div class="pn-field-grid" *ngIf="showCustomDateRange && showJoinedDateField && recipientType === 'MEMBERS'">
          <div class="pn-form-field">
            <label for="startDate" class="col-form-label">Start Date<span class="star"> *</span></label>
            <input id="startDate" type="text" placeholder="--Start Date--" class="form-control date-icon"
              bsDatepicker [(ngModel)]="startDate" name="startDate" [maxDate]="todaysDate"
              (ngModelChange)="getChapterMembersEmails()" [bsConfig]="{ isAnimated: true }">
          </div>
          <div class="pn-form-field">
            <label for="endDate" class="col-form-label">End Date<span class="star"> *</span></label>
            <input id="endDate" type="text" placeholder="--End Date--" class="form-control date-icon" bsDatepicker
              [(ngModel)]="endDate" name="endDate" [maxDate]="todaysDate"
              (ngModelChange)="getChapterMembersEmails()" [bsConfig]="{ isAnimated: true }">
          </div>
        </div>

      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <span class="pn-section-number">02</span>
        <i class="fa fa-envelope pn-icon-spacing" aria-hidden="true"></i> Recipients
      </div>
      <div class="card-body">
        <div class="pn-form-field">
          <label for="to" class="col-form-label">To<span class="star"> *</span></label>
          <ng-select id="to" placeholder="--Select Email--" class="custom"
            [items]="emailList" name="emailId" bindLabel="emailId" bindValue="emailId" [multiple]="true"
            [(ngModel)]="selectedEmail" [disabled]="recipientsLoading"
            [attr.aria-busy]="recipientsLoading" required>
            <ng-template ng-option-tmp let-item="item">
              {{item.emailId}} <span class="pn-manual-label" *ngIf="isManualEmail(item.emailId)">Manually added</span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label" [class.pn-manual-chip]="isManualEmail(item.emailId)">{{item.emailId}}</span>
            </ng-template>
          </ng-select>
          <div class="pn-recipient-error" *ngIf="recipientsLoadError" role="alert">
            Recipients could not be loaded.
            <button type="button" class="btn btn-toyota-outline btn-sm" (click)="getChapterMembersEmails()">Retry loading</button>
          </div>
          <div class="pn-recipient-actions">
            <button type="button" class="btn btn-danger btn-sm" (click)="copyText()"
              *ngIf="selectedEmail.length > 0">Copy to Clipboard</button>
            <button type="button" class="btn btn-danger btn-sm" (click)="openAndCloseMatDialog('open')"
              [disabled]="recipientsLoading || recipientsLoadError"
              *ngIf="selectedSiteIds.length > 0">Add People</button>
            <button type="button" class="btn btn-toyota-outline btn-sm" (click)="removeText()"
              *ngIf="selectedEmail.length > 0">Clear</button>
            <span class="pn-selected-count" *ngIf="recipientsLoading || selectedEmail.length > 0"
              role="status" aria-live="polite" [attr.aria-busy]="recipientsLoading">
              <i class="fa fa-users" aria-hidden="true"></i>
              <ng-container *ngIf="recipientsLoading; else recipientCountLabel">Loading recipients…</ng-container>
              <ng-template #recipientCountLabel><strong>{{selectedEmail.length}}</strong> selected<ng-container *ngIf="selectedManualCount"> ({{selectedManualCount}} manually added)</ng-container></ng-template>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <span class="pn-section-number">03</span>
        <i class="fa fa-comment pn-icon-spacing" aria-hidden="true"></i> Message
      </div>
      <div class="card-body">
        <div class="pn-form-field">
          <div class="pn-field-label-row">
            <label for="subject" class="col-form-label">Subject<span class="star"> *</span></label>
            <span class="pn-character-count"><span>{{ subject ? subject.length : 0 }}</span> / 500</span>
          </div>
          <textarea id="subject" class="form-control" name="subject" placeholder="Enter email subject"
            maxlength="500" rows="3" [(ngModel)]="subject" autocomplete="off" required></textarea>
        </div>
        <div class="pn-form-field">
          <div class="pn-field-label-row">
            <label for="chapterNotification" class="col-form-label">Email Body<span class="star"> *</span>&nbsp;&nbsp;
              <span *ngIf="chapterNotification && chapterNotification.length > 4000">
                <i class="fa fa-exclamation-triangle pn-hint-icon" aria-hidden="true"></i><span class="pn-character-count"><span> Over Limit</span></span>
              </span>
            </label>
            <span class="pn-character-count"><span>{{ chapterNotification ? chapterNotification.length : 0 }}</span> / 4000</span>
          </div>
          <ckeditor [(ngModel)]="chapterNotification" id="chapterNotification" name="chapterNotification" required
            #myckeditor="ngModel" maxlength="4000" [config]="removeToolbarHeaders" debounce="0"></ckeditor>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <span class="pn-section-number">04</span>
        <i class="fa fa-paperclip pn-icon-spacing" aria-hidden="true"></i> Attachments
      </div>
      <div class="card-body">
        <div class="pn-form-field">
          <label class="col-form-label" for="UploadDocument">Upload File</label>
          <input #myInput type="file" id="UploadDocument" (change)="onFileSelected($event)" name="UploadDocument"
            placeholder="Upload" class="hideInput" [multiple]="true"
            accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.txt,.doc,.docx,.xlsx,.csv">
          <label class="pn-upload-label" for="UploadDocument" tabindex="0" role="button"
            (keydown.enter)="myInput.click()" (keydown.space)="$event.preventDefault(); myInput.click()">
            <span class="pn-upload-icon" aria-hidden="true"><i class="fa fa-cloud-upload"></i></span>
            <span class="pn-upload-copy">
              <span class="resource-ellipsis">{{fileList.length ? fileName : 'Choose files to attach'}}</span>
              <span class="formats-font">JPG, JPEG, PNG, PDF, PPT, PPTX, TXT, DOC, DOCX, XLSX, CSV</span>
              <span class="formats-font">500 MB total limit</span>
            </span>
            <span class="pn-upload-action">Browse files</span>
          </label>
        </div>

        <div class="pn-attachment-warnings" *ngIf="attachmentWarnings.length" role="status" aria-live="polite">
          <strong>Some files were not added</strong>
          <ul><li *ngFor="let warning of attachmentWarnings">{{warning}}</li></ul>
          <p class="mb-0">Only the selected files below will be included. You can continue without rejected files.</p>
        </div>

        <div class="pn-table-wrapper pn-file-table-wrapper" *ngIf="fileList.length!=0">
          <p class="selected-files">SELECTED FILES</p>
          <table class="pn-table pn-file-table" id="tabledemo">
            <caption class="sr-only">Files selected for this notification</caption>
            <thead>
              <tr>
                <th scope="col">File Name</th>
                <th scope="col" class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of fileList">
                <td>{{data.name}}</td>
                <td class="text-center">
                  <button type="button" class="pn-icon-button" (click)="deleteFile(data)"
                    [attr.aria-label]="'Delete ' + data.name" title="Delete">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pn-form-footer">
      <div class="pn-footer-feedback">
        <p class="pn-send-help" id="review-help" *ngIf="sendBlockers.length > 0">
          <i class="fa fa-exclamation-triangle pn-hint-icon" aria-hidden="true"></i>
          <span>Before you can review: {{ sendBlockers.join(', ') }}.</span>
        </p>
      </div>
      <div class="pn-footer-actions">
        <button type="button" class="btn btn-toyota-outline pn-submit-btn" data-toggle="modal" (click)="resetClick()"
          [disabled]="isSending"
          data-target="#myModal"><i class="fa fa-undo" aria-hidden="true"></i> RESET</button>
        <button type="submit" id="submitButton"
          class="btn btn-danger pn-submit-btn"
          [disabled]="isSending || sendBlockers.length > 0" [attr.aria-describedby]="sendBlockers.length ? 'review-help' : null">
          <i class="fa fa-eye" aria-hidden="true"></i> Review notification
        </button>
      </div>
    </div>
  </form>
</div>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>

<ng-template #reviewDialog>
  <div class="pn-dialog pn-review-dialog" *ngIf="review" [attr.aria-busy]="isSending">
    <div class="pn-dialog-header">
      <div>
        <h2 class="pn-dialog-title" id="notification-review-title">Review notification</h2>
        <p class="pn-dialog-subtitle mb-0">Check the message and recipients before sending.</p>
      </div>
      <button type="button" class="pn-dialog-close" (click)="closeReview()" [disabled]="isSending" aria-label="Back to edit">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div class="pn-dialog-body">
      <section class="pn-review-section" aria-labelledby="review-audience-title">
        <h3 class="pn-dialog-label" id="review-audience-title">Audience</h3>
        <p>
          <ng-container *ngFor="let part of review.audienceParts; let last = last"
            ><span [class.pn-audience-broad]="part.text === 'All ERGs' || part.text === 'All Sites'">{{part.text}}</span><ng-container *ngIf="!last"> › </ng-container></ng-container>
        </p>
        <details class="pn-review-recipients">
          <summary>{{review.emails.length}} recipients ({{review.manualEmails.length}} manually added)</summary>
          <ul class="pn-recipient-pills">
            <li *ngFor="let email of review.emails" class="pn-recipient-pill"
              [class.pn-recipient-pill--manual]="review.manualEmails.indexOf(email) !== -1">
              {{email}}
              <span class="sr-only" *ngIf="review.manualEmails.indexOf(email) !== -1"> (manually added)</span>
            </li>
          </ul>
        </details>
      </section>
      <section class="pn-review-section" aria-labelledby="review-subject-title">
        <h3 class="pn-dialog-label" id="review-subject-title">Subject</h3>
        <p>{{review.subject}}</p>
      </section>
      <section class="pn-review-section" aria-labelledby="review-message-title">
        <h3 class="pn-dialog-label" id="review-message-title">Message</h3>
        <div class="pn-review-message" [innerHTML]="review.body"></div>
      </section>
      <section class="pn-review-section" aria-labelledby="review-files-title">
        <h3 class="pn-dialog-label" id="review-files-title">Attachments ({{review.files.length}})</h3>
        <ul *ngIf="review.files.length; else noReviewFiles">
          <li *ngFor="let file of review.files">{{file.name}} ({{file.size / 1024 | number:'1.0-1'}} KB)</li>
        </ul>
        <ng-template #noReviewFiles><p>No attachments.</p></ng-template>
      </section>
      <p class="pn-send-status" role="status" aria-live="polite" *ngIf="isSending">{{sendStatus}}</p>
      <div class="alert alert-danger" role="alert" *ngIf="notificationFailure">
        {{errorMsg}} Check Sent Notifications before trying again; the request may have been accepted. Your draft has been kept.
      </div>
    </div>
    <div class="pn-dialog-footer">
      <button type="button" class="btn btn-toyota-outline" (click)="closeReview()" [disabled]="isSending">Back to edit</button>
      <button type="button" class="btn btn-danger" (click)="onsendNotification()" [disabled]="isSending || notificationFailure">
        {{isSending ? 'Sending…' : 'Send to ' + review.emails.length + ' recipients'}}
      </button>
    </div>
  </div>
</ng-template>


<ng-template #callAPIDialog>
  <div class="pn-dialog">
    <div class="pn-dialog-header">
      <div class="pn-dialog-heading">
        <span class="pn-dialog-heading-icon" aria-hidden="true"><i class="fa fa-user-plus"></i></span>
        <div>
          <h2 class="pn-dialog-title" id="add-people-dialog-title">Add People</h2>
          <p class="pn-dialog-subtitle mb-0">{{selectedUserList.length}} selected</p>
        </div>
      </div>
      <button type="button" class="pn-dialog-close" (click)="openAndCloseMatDialog('close')" aria-label="Close">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
    <div class="pn-dialog-body">
      <div class="pn-dialog-search">
        <label class="pn-dialog-label" for="userName">Find people<span class="star"> *</span></label>
        <ng-select #userSelect id="userName" placeholder="Type a name or email" class="custom" [items]="userList"
          bindLabel="userFirstName" appendTo=".cdk-overlay-container" [(ngModel)]="userFirstName" (change)="userSelection($event)"
          (keyup)="findbyEmail($event)" [searchFn]="customSearchFn" [attr.aria-busy]="peopleSearchLoading">
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div>{{item.userFirstName}}</div>
            <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
            <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
          </ng-template>
        </ng-select>
      </div>

      <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="noUser">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span class="pn-alert-text">No people found.</span>
      </div>
      <div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="userFound">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
        <span class="pn-alert-text">Select a person from the results.</span>
      </div>
      <div class="alert alert-danger d-flex align-items-center" role="alert" *ngIf="userExists">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span class="pn-alert-text">This person is already selected.</span>
      </div>
      <div class="alert alert-success d-flex align-items-center" role="alert" *ngIf="usersAdded">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
        <span class="pn-alert-text">People added successfully!</span>
      </div>

      <div class="pn-dialog-idle-hint"
        *ngIf="!peopleSearchLoading && !noUser && !userFound && !userExists && !usersAdded && selectedUserList.length===0">
        <i class="fa fa-search pn-dialog-idle-icon" aria-hidden="true"></i>
        <p class="pn-dialog-idle-text">Search by name or email to find people</p>
      </div>

      <div class="pn-table-wrapper pn-people-table" *ngIf="selectedUserList.length>0">
        <div class="pn-selection-header">
          <h3>Selected people</h3>
          <span>{{selectedUserList.length}}</span>
        </div>
        <table class="pn-table">
          <caption class="sr-only">People selected for this notification</caption>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col" class="text-center">Remove</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of selectedUserList">
              <td>{{data.userFirstName}}</td>
              <td>{{data.emailId}}</td>
              <td class="text-center">
                <button type="button" class="pn-icon-button" (click)="removeUser(data.emailId)"
                  [attr.aria-label]="'Remove ' + data.userFirstName">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pn-dialog-footer">
      <button type="button" class="btn btn-toyota-outline" [disabled]="selectedUserList.length == 0"
        (click)="resetSelectedUser()">Clear selection</button>
      <span class="pn-dialog-footer-spacer"></span>
      <button type="button" class="btn btn-toyota-outline" (click)="openAndCloseMatDialog('close')">Cancel</button>
      <button type="button" (click)="addUsersToEmailList()" class="btn btn-danger"
        [disabled]="selectedUserList.length == 0 || recipientsLoading || recipientsLoadError">Add people</button>
    </div>
  </div>
</ng-template>
